// For Get insurance_carriers
export const GET_ADMIN_INSURANCE_CARRIERS = "GET_ADMIN_INSURANCE_CARRIERS"
export const GET_ADMIN_INSURANCE_CARRIERS_SUCCESS = "GET_ADMIN_INSURANCE_CARRIERS_SUCCESS"
export const GET_ADMIN_INSURANCE_CARRIERS_ERROR = "GET_ADMIN_INSURANCE_CARRIERS_ERROR"

// For Add ADMIN_insurance_carriers
export const CRETE_ADMIN_INSURANCE_CARRIER = "CRETE_ADMIN_INSURANCE_CARRIER"
export const CRETE_ADMIN_INSURANCE_CARRIER_SUCCESS = "CRETE_ADMIN_INSURANCE_CARRIER_SUCCESS"
export const CRETE_ADMIN_INSURANCE_CARRIER_ERROR = "CRETE_ADMIN_INSURANCE_CARRIER_ERROR"

// For Update ADMIN_insurance_carriers
export const UPDATE_ADMIN_INSURANCE_CARRIER = "UPDATE_ADMIN_INSURANCE_CARRIER"
export const UPDATE_ADMIN_INSURANCE_CARRIER_SUCCESS = "UPDATE_ADMIN_INSURANCE_CARRIER_SUCCESS"
export const UPDATE_ADMIN_INSURANCE_CARRIER_ERROR = "UPDATE_ADMIN_INSURANCE_CARRIER_ERROR"